import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { ContactFormType } from '../../../../weborder/Api';
import { Button, List, Typography } from '../../../atoms';
import { ListItem as ListItemType } from '../../../atoms/List';
import { Message as MessageIcon } from '../../../icons';

type Props = {
  contactFormType: ContactFormType;
  onContactUs: () => void;
  onLogin: () => void;
  translate: any;
};

const useStyles = makeStyles((theme: Theme) => ({
  guestProfile: {
    padding: theme.spacing(3, 0, 0),

    '& .primaryPanel': {
      padding: theme.spacing(0, 2),
    },
  },

  loginButton: {
    '& .MuiButton-label': {
      ...theme.typography.body2,
      color: theme.palette.grey[600],
    },
  },

  listItems: {
    padding: theme.spacing(1.75, 0, 3),

    '& .MuiListItem-root:only-child': {
      borderBottom: '1px solid transparent',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),

      '&:hover': {
        borderBottomColor: theme.palette.primary.main,
      },
    },
  },

  [theme.breakpoints.up('sm')]: {
    '& .primaryPanel': {
      padding: 0,
    },
  },

  [theme.breakpoints.up('lg')]: {
    guestProfile: {
      paddingBottom: theme.spacing(3),

      '&.reducedBottomPadding': {
        paddingBottom: theme.spacing(1.5),
      },

      '& .primaryPanel': {
        padding: theme.spacing(0),
      },
    },

    listItems: {
      padding: theme.spacing(2, 0, 0),

      '& .MuiListItem-root:only-child': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
  },
}));

export function GuestProfilePartial(props: Props): JSX.Element {
  const classes = useStyles();
  const { contactFormType, onContactUs, onLogin, translate } = props;

  const renderContactUs = () => {
    const items: ListItemType[] = [
      {
        key: 'guest-profile-contact-us',
        leftIcon: <MessageIcon />,
        onClick: onContactUs,
        primaryContent: translate('Contact_us'),
        rightIcon: null,
      },
    ];
    return <List className={classes.listItems} items={items} />;
  };

  const hasContactUs = contactFormType === ContactFormType.Intercom;

  const guestProfileStyles = clsx(
    classes.guestProfile,
    hasContactUs && 'reducedBottomPadding',
  );

  return (
    <div className={guestProfileStyles}>
      <div className="primaryPanel">
        <Typography variant="h3">
          {translate('menu_statusPanel_guestLoggedIn')}
        </Typography>

        <Button
          data-fd="guest-login-button"
          className={classes.loginButton}
          onClick={onLogin}
          variant="text"
        >
          {translate('menu_statusPanel_phoneNumberLoginAlt')}
        </Button>
      </div>

      {hasContactUs && renderContactUs()}
    </div>
  );
}
